/*
 * Jira Ticket:
 * Created Date: Fri, 17th Jan 2020, 16:14:54 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

export default ({ type, resource, result }) => {
  // override results returned from backend here, e.g. create required field names
  // example
  // if (resource === 'Configuration') {
  //   result.data.id = 'configuration'; // fake the ID
  // }
  return result;
};
